import { api } from "@/lib/api";

export const CATEGORY_LABEL = {
  "dev-tools": "Developer tools",
  "productivity": "Productivity",
  "marketing": "Marketing",
  "sales": "Sales",
  "analytics": "Analytics",
  "design": "Design",
  "finance": "Finance",
  "hr": "HR",
  "ecommerce": "E-commerce",
  "ai-ml": "AI / ML",
  "other": "Other",
};

export const CATEGORIES = Object.keys(CATEGORY_LABEL);

export async function listOwnProducts() {
  const { data } = await api.get("/products");
  return data.items;
}

export async function getOwnProduct(id) {
  const { data } = await api.get(`/products/${id}`);
  return data.product;
}

export async function createProduct(payload) {
  const { data } = await api.post("/products", payload);
  return data.product;
}

export async function updateProduct(id, payload) {
  const { data } = await api.patch(`/products/${id}`, payload);
  return data.product;
}

export async function deleteProduct(id) {
  await api.delete(`/products/${id}`);
}

export async function publishProduct(id) {
  const { data } = await api.post(`/products/${id}/publish`);
  return data.product;
}

export async function unpublishProduct(id) {
  const { data } = await api.post(`/products/${id}/unpublish`);
  return data.product;
}

export async function uploadLogo(id, file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post(`/products/${id}/logo`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.product;
}

export async function listPublicProducts({ q, category, page = 1, pageSize = 12 } = {}) {
  const params = new URLSearchParams();
  if (q) params.set("q", q);
  if (category) params.set("category", category);
  params.set("page", String(page));
  params.set("page_size", String(pageSize));
  const { data } = await api.get(`/products/public?${params.toString()}`);
  return data;
}

export async function getPublicProduct(slug) {
  const { data } = await api.get(`/products/public/${slug}`);
  return data.product;
}
